export const MEAL_VOUCHERS_TOTAL_VALUE_MIN = 1.09
export const MEAL_VOUCHERS_TOTAL_VALUE_MAX = 10

export const MEAL_VOUCHERS_CONTRIBUTION_VALUE_MIN = 1.09
export const MEAL_VOUCHERS_CONTRIBUTION_VALUE_MAX = 10
